// extracted by mini-css-extract-plugin
module.exports = {"card":"views_card__31xXG","loginCard":"views_loginCard__1PFyO"};